import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Content = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`

export const IntroMessage = styled(Box)`
  ${({ theme }) => css`
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    text-align: center;
    color: ${theme.colors.secondary};
  `}
`

export const BodyMessage = styled(Box)`
  ${({ theme }) => css`
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    text-align: center;
    color: ${theme.colors.gray.dark};
  `}
`

export const ButtonWrapper = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 8px;
`
